<template>
     <claim-approve-popout-tabs />
</template>

<script>

import ClaimApprovePopoutTabs from '@/components/ClaimApprovePopoutTabs.vue'

export default {
    name:'ClaimQuickApprovePopout',
    components: {
        ClaimApprovePopoutTabs
    },
    data: () => {
        return {

        }
    },
    beforeMount() {
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
    },
    methods: {
    }
}
</script>

